import { Action } from "./action";
import { Ruche } from "./ruche";


export class InterRuche {
    id_histo_ruche: string = '-1';
    ruche: Ruche;
    id_inter_rucher: string;
    pds_kilos: string;
    pds_grammes: string;
    force_ruche: string = '-1';
    varroas: string = '-1';
    active: string;
    actions: Action[] = [];
    actions_a_faire: Action[] = [];

  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/models/interRuche.ts